import React from 'react';
import {
  Box,
  IconButton,
  Tooltip,
  useTheme,
  alpha,
} from '@mui/material';
import {
  Videocam,
  VideocamOff,
  Mic,
  MicOff,
  ScreenShare,
  StopScreenShare,
  ExitToApp,
  Edit,
  EditOff,
} from '@mui/icons-material';

const VideoControls = ({
  isVideoEnabled,
  isAudioEnabled,
  isScreenSharing,
  showWhiteboard,
  onToggleVideo,
  onToggleAudio,
  onToggleScreenShare,
  onToggleWhiteboard,
  onLeave,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        p: 2,
        bgcolor: alpha(theme.palette.primary.main, 0.1),
        borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
      }}
    >
      <Tooltip title={isVideoEnabled ? 'Turn off camera' : 'Turn on camera'}>
        <IconButton
          onClick={onToggleVideo}
          sx={{
            bgcolor: isVideoEnabled ? theme.palette.primary.main : 'error.main',
            color: 'white',
            '&:hover': {
              bgcolor: isVideoEnabled ? theme.palette.primary.dark : 'error.dark',
            },
          }}
        >
          {isVideoEnabled ? <Videocam /> : <VideocamOff />}
        </IconButton>
      </Tooltip>

      <Tooltip title={isAudioEnabled ? 'Mute microphone' : 'Unmute microphone'}>
        <IconButton
          onClick={onToggleAudio}
          sx={{
            bgcolor: isAudioEnabled ? theme.palette.primary.main : 'error.main',
            color: 'white',
            '&:hover': {
              bgcolor: isAudioEnabled ? theme.palette.primary.dark : 'error.dark',
            },
          }}
        >
          {isAudioEnabled ? <Mic /> : <MicOff />}
        </IconButton>
      </Tooltip>

      <Tooltip title={isScreenSharing ? 'Stop sharing' : 'Share screen'}>
        <IconButton
          onClick={onToggleScreenShare}
          sx={{
            bgcolor: isScreenSharing ? theme.palette.warning.main : theme.palette.primary.main,
            color: 'white',
            '&:hover': {
              bgcolor: isScreenSharing ? theme.palette.warning.dark : theme.palette.primary.dark,
            },
          }}
        >
          {isScreenSharing ? <StopScreenShare /> : <ScreenShare />}
        </IconButton>
      </Tooltip>

      <Tooltip title={showWhiteboard ? 'Hide whiteboard' : 'Show whiteboard'}>
        <IconButton
          onClick={onToggleWhiteboard}
          sx={{
            bgcolor: showWhiteboard ? theme.palette.success.main : theme.palette.primary.main,
            color: 'white',
            '&:hover': {
              bgcolor: showWhiteboard ? theme.palette.success.dark : theme.palette.primary.dark,
            },
          }}
        >
          {showWhiteboard ? <Edit /> : <EditOff />}
        </IconButton>
      </Tooltip>

      <Tooltip title="Leave session">
        <IconButton
          onClick={onLeave}
          sx={{
            bgcolor: 'error.main',
            color: 'white',
            '&:hover': {
              bgcolor: 'error.dark',
            },
          }}
        >
          <ExitToApp />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default VideoControls;

